import { IRootState } from '../../../store'
import { IPcrSummary } from '../store/home.types'

export const getPcrSelector = (state: IRootState): IPcrSummary | null => state.home.pcr
